import styled from '@eduzz/houston-styles';

export const Container = styled.div`
  margin-bottom: ${({ theme }) => theme.spacing.xs};
`;

export const BannerImage = styled.img`
  width: 100%;
`;
